export const savePrice = (data)=>{
    return {
        type:"AD_PRICE",
        payload:data
    }
}